import FilterInput from 'components/Filters/FilterPanel/subcomponents/Input'
import CheckboxGroupFilter from 'components/Filters/FilterPanel/subcomponents/CheckboxGroupFilter'
import RadioGroupFilter from 'components/Filters/FilterPanel/subcomponents/RadioGroupFilter'
import DatePicker from 'components/Filters/FilterPanel/subcomponents/DatePicker'
import SwitcherFilter from 'components/Filters/FilterPanel/subcomponents/Switcher'
import CheckboxSelector from 'components/Filters/FilterPanel/subcomponents/CheckboxSelector'
import FromToSelector from 'components/Filters/FilterPanel/subcomponents/FromToSelector'
import Select from 'components/Filters/FilterPanel/subcomponents/Select'

export default {
  input: FilterInput,
  'radio group': RadioGroupFilter,
  'checkbox group': CheckboxGroupFilter,
  'checkbox selector': CheckboxSelector,
  datepicker: DatePicker,
  switcher: SwitcherFilter,
  select: Select,
  'from-to selector': FromToSelector,
}
